webpackJsonp([213720915766396],{

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n        padding-top: 0;\n\t"], ["\n        padding-top: 0;\n\t"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n        flex-direction: column;\n\t"], ["\n        flex-direction: column;\n\t"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n        flex: none;\n\t"], ["\n        flex: none;\n\t"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n            padding-right: 0;\n        "], ["\n            padding-right: 0;\n        "]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n            padding-left: 0;\n        "], ["\n            padding-left: 0;\n        "]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n\t\theight: 228px;\n\t"], ["\n\t\theight: 228px;\n\t"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n\t\theight: 196px;\n\t"], ["\n\t\theight: 196px;\n\t"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n\t\theight: 198px;\n\t"], ["\n\t\theight: 198px;\n\t"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n        font-size: 12px;\n\t"], ["\n        font-size: 12px;\n\t"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n        font-size: 14px;\n    "], ["\n        font-size: 14px;\n    "]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(29);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _lodash = __webpack_require__(27);
	
	var _polished = __webpack_require__(12);
	
	var _components = __webpack_require__(11);
	
	var _settings = __webpack_require__(32);
	
	var _themes = __webpack_require__(15);
	
	var _global = __webpack_require__(5);
	
	var _type = __webpack_require__(10);
	
	var _utils = __webpack_require__(4);
	
	var _colors = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PROJECTS_PAGE_SIZE = 10;
	
	var Projects = function (_Component) {
	    _inherits(Projects, _Component);
	
	    function Projects() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Projects);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	            data: [],
	            visibleCount: PROJECTS_PAGE_SIZE
	        }, _this.componentWillMount = function () {
	            _this.props.fetchSettings();
	            _this.setState({
	                data: _this.props.data.allWordpressProjects.edges
	            });
	        }, _this.loadMore = function () {
	            _this.setState({
	                visibleCount: _this.state.visibleCount + PROJECTS_PAGE_SIZE
	            });
	        }, _this.renderProjects = function () {
	            var _this$state = _this.state,
	                data = _this$state.data,
	                visibleCount = _this$state.visibleCount;
	
	
	            if (!data || data.length === 0) return null;
	
	            var visible = data.slice(0, visibleCount);
	            var hasMore = data.length > visibleCount;
	
	            var projects = visible.map(function (project, i) {
	                var acf = JSON.parse(project.node.acf_json);
	
	                return _react2.default.createElement(
	                    Item,
	                    { key: i },
	                    _react2.default.createElement(ListImageLink, {
	                        image: acf.hero_image.sizes.large,
	                        to: "/project/" + project.node.slug
	                    }),
	                    _react2.default.createElement(
	                        TitleLink,
	                        { to: "/project/" + project.node.slug },
	                        project.node.title
	                    )
	                );
	            });
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    Listing,
	                    null,
	                    projects
	                ),
	                hasMore && _react2.default.createElement(
	                    LoadMoreWrapper,
	                    null,
	                    _react2.default.createElement(
	                        LoadMoreButton,
	                        { onClick: _this.loadMore },
	                        "View More"
	                    )
	                )
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Projects.prototype.render = function render() {
	        var splashActive = this.props.settings.splashActive;
	        var data = this.state.data;
	
	
	        var firstPostACF = void 0;
	        if (data) {
	            firstPostACF = JSON.parse(data[0].node.acf_json);
	        }
	
	        return _react2.default.createElement(
	            Wrapper,
	            {
	                active: splashActive == false
	            },
	            data && firstPostACF && _react2.default.createElement(_components.MetaTags, {
	                title: "Paul Conrad Architects \u2014 Projects",
	                description: "",
	                url: "https://www.conradarchitects.com/projects",
	                image: firstPostACF.hero_image.sizes.medium2
	            }),
	            this.renderProjects()
	        );
	    };
	
	    return Projects;
	}(_react.Component);
	
	var Wrapper = _styledComponents2.default.div.withConfig({
	    displayName: "Projects__Wrapper",
	    componentId: "sc-1pkcndd-0"
	})(["display:flex;flex-direction:column;align-items:center;width:100%;z-index:2;padding-top:10rem;transition:all 0.75s ease;transition-delay:0.4s;will-change:transform;transform:translateY(100px);opacity:0;", " ", ""], _utils.media.phone(_templateObject), function (props) {
	    if (props.active) return (0, _styledComponents.css)(["transform:translateY(0);opacity:1;"]);
	});
	
	var Listing = _styledComponents2.default.div.withConfig({
	    displayName: "Projects__Listing",
	    componentId: "sc-1pkcndd-1"
	})(["", ";display:flex;flex-flow:row wrap;margin-bottom:10rem;", ""], _global.innerContainer, _utils.media.phone(_templateObject2));
	
	var Item = _styledComponents2.default.div.withConfig({
	    displayName: "Projects__Item",
	    componentId: "sc-1pkcndd-2"
	})(["flex:0 1 50%;margin-bottom:5rem;box-sizing:border-box;", " &:nth-child(odd){padding-right:2.5rem;", "}&:nth-child(even){padding-left:2.5rem;", "}"], _utils.media.phone(_templateObject3), _utils.media.phone(_templateObject4), _utils.media.phone(_templateObject5));
	
	var ListImageLink = (0, _styledComponents2.default)(_gatsbyLink2.default).withConfig({
	    displayName: "Projects__ListImageLink",
	    componentId: "sc-1pkcndd-3"
	})(["display:flex;position:relative;background-image:url(", ");", " height:294px;width:100%;", " ", " ", ""], function (props) {
	    return props.image;
	}, _global.bgImage, _utils.media.laptop(_templateObject6), _utils.media.tablet(_templateObject7), _utils.media.phone(_templateObject8));
	
	var TitleLink = (0, _styledComponents2.default)(_gatsbyLink2.default).withConfig({
	    displayName: "Projects__TitleLink",
	    componentId: "sc-1pkcndd-4"
	})(["display:flex;margin-top:10px;font-family:'Scto';font-weight:300;font-size:16px;line-height:1;color:", ";", ";", ""], _colors.grey, _global.hoverState, _utils.media.tablet(_templateObject9));
	
	var LoadMoreWrapper = _styledComponents2.default.div.withConfig({
	    displayName: "Projects__LoadMoreWrapper",
	    componentId: "sc-1pkcndd-5"
	})(["", ";display:flex;justify-content:center;margin-top:2rem;margin-bottom:10rem;"], _global.innerContainer);
	
	var LoadMoreButton = _styledComponents2.default.div.withConfig({
	    displayName: "Projects__LoadMoreButton",
	    componentId: "sc-1pkcndd-6"
	})(["background:#F5F4F2;color:", ";font-size:16px;line-height:1;padding:14px 32px;cursor:pointer;", ";", ""], _colors.grey, _global.hoverState, _utils.media.phone(_templateObject10));
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        fetchSettings: function fetchSettings() {
	            dispatch((0, _settings.fetchSettings)());
	        },
	        updateSettings: function (_updateSettings) {
	            function updateSettings(_x) {
	                return _updateSettings.apply(this, arguments);
	            }
	
	            updateSettings.toString = function () {
	                return _updateSettings.toString();
	            };
	
	            return updateSettings;
	        }(function (setting) {
	            dispatch(updateSettings(setting));
	        })
	    };
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        settings: state.settings.settings
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Projects);
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-js-fc74a5b4dd3cd566d82c.js